import React from 'react'
import theme from 'redesign/themes/main'
import SvgWrapper from '../SvgWrapper'
import { DEFAULT_LINE_STROKE, ICON_SIZE, ICON_VIEWBOX } from './constants'
import type { IconProps } from './types'

const OpenIcon: React.FC<IconProps> = ({
  color = theme.palette.info.main,
  size = ICON_SIZE.medium,
  viewBox = ICON_VIEWBOX.medium,
  strokeWidth = DEFAULT_LINE_STROKE,
}) => (
  <SvgWrapper aria-label="Open" size={size} viewBox={viewBox} fill="none">
    <circle
      cx="12"
      cy="12"
      r="9.5"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="4.5 3"
    />
  </SvgWrapper>
)

export default OpenIcon
